export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                ID канала
  //--------------------------------------------------------------------------
  idChannel: {
    type: Number,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});